export default "__VITE_ASSET__174359d7__"